
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infiltration/progress",
      function () {
        return require("private-next-pages/infiltration/progress.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infiltration/progress"])
      });
    }
  